import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CmpsIconModule, CmpsIconRegistry } from '@cmps/ng-uikit';
import { mdiExclamationThick, mdiInformationOutline } from '@mdi/js';

import { CmpsInsightCoachingCommitmentComponent } from './insight-coaching-commitment.component';

@NgModule({
    declarations: [CmpsInsightCoachingCommitmentComponent],
    imports: [CmpsIconModule],
    exports: [CmpsInsightCoachingCommitmentComponent],
})
export class CmpsInsightCoachingCommitmentModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['information-outline', mdiInformationOutline],
            ['exclamation-thick', mdiExclamationThick],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
